import { PaymentProviderEnum, PaymentTypeEnum } from 'constants-payments';

import { GroupRole } from '../GroupRole';
import { OptionType } from '../baseTypes/OptionType';

export enum RecurrenceInterval {
  RecurrenceIntervalDaily = 'RECURRENCE_INTERVAL_DAILY',
  RecurrenceIntervalMonthly = 'RECURRENCE_INTERVAL_MONTHLY',
  RecurrenceIntervalUnknown = 'RECURRENCE_INTERVAL_UNKNOWN',
  RecurrenceIntervalWeekly = 'RECURRENCE_INTERVAL_WEEKLY',
  RecurrenceIntervalYearly = 'RECURRENCE_INTERVAL_YEARLY'
}

export type PaymentFeaturePaymentAmountType = {
  _id: string;
  amount: number;
  // todo: enum for currency?
  currency?: string;
  type: PaymentTypeEnum;
};

export type PriceTimeRangeType = {
  startTime: string;
  endTime: string;
  priceRatio: number;
};

export type PaymentFeatureDayRuleType = {
  isOpen: boolean;
  priceTimeRanges: PriceTimeRangeType[];
};

export type PaymentFeatureWeekRuleType = {
  MONDAY?: PaymentFeatureDayRuleType;
  TUESDAY?: PaymentFeatureDayRuleType;
  WEDNESDAY?: PaymentFeatureDayRuleType;
  THURSDAY?: PaymentFeatureDayRuleType;
  FRIDAY?: PaymentFeatureDayRuleType;
  SATURDAY?: PaymentFeatureDayRuleType;
  SUNDAY?: PaymentFeatureDayRuleType;
};

export type PaymentFeatureRuleType = {
  groupRole: GroupRole;
  priceRatio: number;
  weekTimeRulesEnabled: boolean;
  weekTimeRules: PaymentFeatureWeekRuleType;
  canOverridePrice: boolean;
};

export type SubscriptionProperties = {
  subscriptionDetailsId?: string;
  frequency: RecurrenceInterval;
  endDateOption: 'never' | 'after';
  totalCounts: number;
  anyoneCanCancel: boolean;
};

export type PaymentFeatureProperties = {
  /** @deprecated - 5.190.0 - use productIds */
  taxes?: OptionType[];
  paymentProvider: PaymentProviderEnum;
  /** @deprecated - 5.190.0 - use productIds */
  amounts: PaymentFeaturePaymentAmountType[];
  weekTimeRulesEnabled: boolean;
  weekTimeRules: PaymentFeatureWeekRuleType;
  rules: PaymentFeatureRuleType[];
  data?: any;
  contactId?: string;
  productIds?: string[];
  subscriptionEnabled: boolean;
  subscription?: SubscriptionProperties;
  transactionId?: string;
};
